/* eslint-disable react/jsx-no-undef */
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { 
  Box, Drawer, IconButton, List, ListItem, ListItemButton,
  ListItemIcon, ListItemText, Typography, Collapse
} from '@mui/material';
import { 
  ChevronLeft,
  HomeOutlined, ShoppingCartOutlined,
  ReceiptLongOutlined, Restaurant, 
  LocalPharmacy, Inventory2Outlined, Inventory,
  ExpandLess, ExpandMore, Category, LocalShipping,
  ShoppingBasket, ListAlt, LunchDining, LocalBar, LocalCafe,
  FitnessCenter, People, AttachMoney, Assignment, Schedule,
  ProductionQuantityLimits, Man, Settings,
  TableBar, Bed, MyLocation, Place,
  EmojiPeopleOutlined, BookOnline,
  BusinessOutlined, ManageAccountsOutlined,
  ViewList, Add, Sell, Person2Outlined, SubscriptOutlined,
  ReceiptOutlined, ManageHistory
} from '@mui/icons-material';
import FlexBetween from './FlexBetween';
import ConfigurationFidelite from 'scenes/Configuration/ConfigurationFidelite';

/* ===================== MODULES ===================== */
const ALL_MODULES = {
  dashboard: {
    text: "Dashboard",
    icon: <HomeOutlined />,
    path: "depot/dashboard",
    accessibleBy: ['all']
  },

  // depot: {
  //   text: "Dépot",
  //   icon: <ReceiptLongOutlined />,
  //   path: "depot",
  //   accessibleBy: ['depot', 'admin', 'proprietaire', 'manager'],
  //   // subItems : [{
  //   //   text : "Succursale",
  //   //   icon : <BusinessOutlined/>,
  //   //   path : "depot/succursale",
  //   //   accessibleBy: ['admin', 'proprietaire', 'manager'],
  //   // }]
  // },
    Annexe: {
    text: "Annexe",
    icon: <BusinessOutlined />,
    path: "depot/succursale",
    accessibleBy: ['admin', 'proprietaire', 'manager', 'depot', 'gym']
  },

    GestionStock: {
    text: "Gestion Stock",
    icon: <ManageHistory />,
    path: "stocks-succursale",
    accessibleBy: ['all']
  },

  pharmacie: {
    text: "Pharmacie",
    icon: <LocalPharmacy />,
    path: "pharmacie",
    accessibleBy: ['pharmacie', 'admin']
  },

  restaurant: {
    text: "Restaurant / Hôtel",
    icon: <Restaurant />,
    path: "restaurant",
    accessibleBy: ['restaurant', 'admin'],
    subItems: [
      {
        text: "Catégories",
        icon: <Category />,
        children: [
          { text: "Menu", icon: <LunchDining />, path: "restaurant/categories-menu" },
          { text: "Boissons", icon: <LocalBar />, path: "restaurant/categories-boissons" }
        ]
      },
      { text: "Plats", icon: <LunchDining />, path: "restaurant/plats" },
      { text: "Boissons", icon: <LocalCafe />, path: "restaurant/boissons" },
      { text: "Tables", icon: <TableBar />, path: "restaurant/tables" },
      { text: "Chambres", icon: <Bed />, path: "restaurant/chambres" },
      { text: "Locations", icon: <MyLocation />, path: "restaurant/locations" },
      { text: "Réservations", icon: <Place />, path: "restaurant/reservations" },
      { text: "Employés", icon: <EmojiPeopleOutlined />, path: "restaurant/employes" },
      { text: "Dépenses", icon: <BookOnline />, path: "restaurant/depenses" }
    ]
  },

  shop: {
    text: "Shop",
    icon: <ShoppingCartOutlined />,
    path: "shop",
    accessibleBy: ['shop', 'admin']
  },

  gym: {
    text: "GYM",
    icon: <FitnessCenter />,
    path: "gym",
    accessibleBy: ['gym', 'admin'],
    subItems: [
      { text: "Clients", icon: <People />, path: "gym/clients" },
      { text: "Abonnements", icon: <Assignment />, path: "gym/abonnements" },
      { text: "Paiements", icon: <AttachMoney />, path: "gym/paiements" },
      { text: "Coachs", icon: <Man />, path: "gym/coaches" },
      { text: "Produits", icon: <ProductionQuantityLimits />, path: "gym/shop-products" },
      { text: "Planning", icon: <Schedule />, path: "gym/emploi-du-temps" },
      { text: "Settings", icon: <Settings />, path: "gym/settings" }
    ]
  },

  inventaire: {
    text: "Inventaire",
    icon: <Inventory2Outlined />,
    path: "inventaire",
    accessibleBy: ['admin', 'shop', 'restaurant', 'depot', 'pharmacie'],
    subItems: [
      { text: "Catégories", icon: <Category />, path: "categories" },
      {
        text: "Fournisseurs",
        icon: <LocalShipping />,
        children: [
          { text: "Liste", icon: <ListAlt />, path: "fournisseurs/liste" },
          { text: "Achats", icon: <ShoppingBasket />, path: "fournisseurs/achats" }
        ]
      },
      { text: "Clients", icon: <People />, path: "clients" },
       {
      text: "Ventes",
      icon: <ReceiptOutlined />,
      children: [
        // { text: "Nouvelle vente", icon: <Add />, path: "ventes" },
        { text: "Historique Vente", icon: <ManageHistory />, path: "ventes" }
      ]
    },
      { text: "Produits", icon: <Inventory />, path: "produits" }
    ]
  },
 Manage_User: {
    text: "Manage User",
    icon: <ManageAccountsOutlined />,
    path: "depot/manage-user",
    accessibleBy: ['admin', 'proprietaire', 'manager', 'depot', 'gym'],
    // subItems: [
    //   {
    //     text: "Manager",
    //     icon: <Person2Outlined />,
    //     children: [
    //       { text: "Listes", icon: <ViewList />, path: "depot/manage-user/manager/list" },
    //       { text: "Ajouter", icon: <Add />, path: "depot/manage-user/manager/add" }
    //     ]
    //   },
    //   {
    //     text: "Caissier",
    //     icon: <Sell />,
    //     children: [
    //       { text: "Listes", icon: <ViewList />, path: "depot/manage-user/caissier/list" },
    //       { text: "Ajouter", icon: <Add />, path: "depot/manage-user/caissier/add" }
    //     ]
    //   },
    //   {
    //     text: "Proprietaire",
    //     icon: <BusinessOutlined />,
    //     children: [
    //       { text: "Listes", icon: <ViewList />, path: "depot/manage-user/proprietaire/list" },
    //       { text: "Ajouter", icon: <Add />, path: "depot/manage-user/proprietaire/add" }
    //     ]
    //   },
      
    // ]
  },
    Abonnement: {
    text: "Abonnement",
    icon: <SubscriptOutlined />,
    path: "abonnements",
    accessibleBy: ['all']
  },

   Session: {
    text: "Session",
    icon: <Schedule />,
    path: "sessions-caisse",
    accessibleBy: ['admin', 'proprietaire', 'manager', 'depot'],
    subItems : [{
      text : "Liste",
      icon : <ViewList/>,
      path : "depot/sessions-caisse",
      accessibleBy: ['admin', 'proprietaire', 'manager', 'depot'],
    }]
  },


    ConfigurationFidelite: {
    text: "Configuration",
    icon: <Settings />,
    path: "config-fidelite",
    accessibleBy: ['all']
  },
};

/* ===================== SIDEBAR ===================== */
const Sidebar = ({ drawerWidth, isSidebarOpen, setIsSidebarOpen, isNonMobile }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  // const [openSubmenu, setOpenSubmenu] = useState({});
  const [openSubmenu, setOpenSubmenu] = useState({
  restaurant: true,
  gym: true,
});


  const user = useSelector((state) => state.global.user);
  const currentUser = user || JSON.parse(localStorage.getItem('user') || '{}');
  const userModule = currentUser.module_actif?.toLowerCase() || 'default';

  const handleToggle = (key) => {
    setOpenSubmenu(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const isModuleAccessible = (module) => {
    if (userModule === 'admin') return true;
    if (module.accessibleBy?.includes('all')) return true;
    return module.accessibleBy?.includes(userModule);
  };

  const renderModuleItem = (module) => {
    const hasSubItems = module.subItems?.length > 0;
    const isRestaurant = module.path === "restaurant";

    return (
      <React.Fragment key={module.path}>
        <ListItem disablePadding>
          <ListItemButton
onClick={() =>
  hasSubItems
    ? handleToggle(module.path)
    : navigate(`/${module.path}`)
}

            sx={{ color: "#fff" }}
          >
            <ListItemIcon sx={{ color: "#fff", ml: "1.5rem" }}>
              {module.icon}
            </ListItemIcon>
            <ListItemText primary={module.text} />
            {hasSubItems && !isRestaurant &&
              (openSubmenu[module.path] ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>
        </ListItem>

        {hasSubItems && (
<Collapse
  in={openSubmenu[module.path]}
  timeout="auto"
  unmountOnExit
>

            <List disablePadding>
              {module.subItems.map(sub => (
                <React.Fragment key={sub.text}>
                  <ListItemButton
                    sx={{ pl: 6, color: "#fff" }}
                    onClick={() =>
                      sub.children
                        ? handleToggle(sub.text)
                        : navigate(`/${sub.path}`)
                    }
                  >
                    <ListItemIcon sx={{ color: "#fff" }}>
                      {sub.icon}
                    </ListItemIcon>
                    <ListItemText primary={sub.text} />
                    {sub.children &&
                      (openSubmenu[sub.text] ? <ExpandLess /> : <ExpandMore />)}
                  </ListItemButton>

                  {sub.children && (
                    <Collapse in={openSubmenu[sub.text]} timeout="auto">
                      <List disablePadding>
                        {sub.children.map(child => (
                          <ListItemButton
                            key={child.path}
                            sx={{ pl: 8, color: "#fff" }}
                            onClick={() => navigate(`/${child.path}`)}
                          >
                            <ListItemIcon sx={{ color: "#fff" }}>
                              {child.icon}
                            </ListItemIcon>
                            <ListItemText primary={child.text} />
                          </ListItemButton>
                        ))}
                      </List>
                    </Collapse>
                  )}
                </React.Fragment>
              ))}
            </List>
          </Collapse>
        )}
      </React.Fragment>
    );
  };

  return (
    <Drawer
      open={isSidebarOpen}
      variant="persistent"
      anchor="left"
      sx={{
        width: drawerWidth,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          backgroundColor: "#000",
          color: "#fff"
        }
      }}
    >
      <Box m="1.5rem">
        <FlexBetween>
          <Typography variant="h4" fontWeight="bold">
            SGPME
          </Typography>
          {!isNonMobile && (
            <IconButton
              onClick={() => setIsSidebarOpen(false)}
              sx={{ color: "#fff" }}
            >
              <ChevronLeft />
            </IconButton>
          )}
        </FlexBetween>
      </Box>

      <List>
        {Object.values(ALL_MODULES)
          .filter(isModuleAccessible)
          .map(renderModuleItem)}
      </List>
    </Drawer>
  );
};

export default Sidebar;
